//
//
// For notifications
//

const { setLanguage } = require("react-geocode");

const deploymentEnvironment = true; //! false = test | true = live

var SUPER_ADMIN_DETAILS = {
  UUID: "",
  email: "",
};

var defaultWidth =
  window.screen.width > 768
    ? (window.screen.width * 1) / 3
    : window.screen.width;

var style = {
  Wrapper: {},
  Containers: {
    DefaultStyle: {
      position: "fixed",
      width: defaultWidth,
      padding: "5px 5px 5px 10px",
      zIndex: 9998,
      WebkitBoxSizing: "",
      MozBoxSizing: "",
      boxSizing: "",
      height: "auto",
      display: "inline-block",
      border: "0",
      fontSize: "18px",
      WebkitFontSmoothing: "antialiased",
      fontFamily: '"Nunito Sans", Helvetica Neue","Roboto",Arial,sans-serif',
      fontWeight: "400",
      color: "#FFFFFF",
    },

    tl: {
      top: "0px",
      bottom: "auto",
      left: "0px",
      right: "auto",
    },

    tr: {
      top: "0px",
      bottom: "auto",
      left: "auto",
      right: "0px",
    },

    tc: {
      top: "0px",
      bottom: "auto",
      margin: "0 auto",
      left: "50%",
      marginLeft: -(defaultWidth / 2),
    },

    bl: {
      top: "auto",
      bottom: "0px",
      left: "0px",
      right: "auto",
    },

    br: {
      top: "auto",
      bottom: "0px",
      left: "auto",
      right: "0px",
    },

    bc: {
      top: "auto",
      bottom: "0px",
      margin: "0 auto",
      left: "50%",
      marginLeft: -(defaultWidth / 2),
    },
  },

  NotificationItem: {
    DefaultStyle: {
      position: "relative",
      width: "100%",
      cursor: "pointer",
      borderRadius: "4px",
      fontSize: "14px",
      margin: "10px 0 0",
      padding: "10px",
      display: "block",
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box",
      opacity: 0,
      transition: "all 0.5s ease-in-out",
      WebkitTransform: "translate3d(0, 0, 0)",
      transform: "translate3d(0, 0, 0)",
      willChange: "transform, opacity",

      isHidden: {
        opacity: 0,
      },

      isVisible: {
        opacity: 1,
      },
    },

    success: {
      borderTop: 0,
      // backgroundColor: "#a1e82c",
      backgroundColor: "#55a44e",
      WebkitBoxShadow: 0,
      MozBoxShadow: 0,
      boxShadow: 0,
    },

    error: {
      borderTop: 0,
      backgroundColor: "#fc727a",
      WebkitBoxShadow: 0,
      MozBoxShadow: 0,
      boxShadow: 0,
    },

    warning: {
      borderTop: 0,
      backgroundColor: "#ffbc67",
      WebkitBoxShadow: 0,
      MozBoxShadow: 0,
      boxShadow: 0,
    },

    info: {
      borderTop: 0,
      backgroundColor: "#63d8f1",
      WebkitBoxShadow: 0,
      MozBoxShadow: 0,
      boxShadow: 0,
    },
  },

  Title: {
    DefaultStyle: {
      fontSize: "30px",
      margin: "0",
      padding: 0,
      fontWeight: "bold",
      color: "#FFFFFF",
      display: "block",
      left: "15px",
      position: "absolute",
      top: "50%",
      marginTop: "-15px",
    },
  },

  MessageWrapper: {
    DefaultStyle: {
      marginLeft: "55px",
      marginRight: "30px",
      padding: "0 12px 0 0",
      color: "#FFFFFF",
      maxWidthwidth: "89%",
    },
  },

  Dismiss: {
    DefaultStyle: {
      fontFamily: "inherit",
      fontSize: "21px",
      color: "#000",
      float: "right",
      position: "absolute",
      right: "10px",
      top: "50%",
      marginTop: "-13px",
      backgroundColor: "#FFFFFF",
      display: "block",
      borderRadius: "50%",
      opacity: ".4",
      lineHeight: "11px",
      width: "25px",
      height: "25px",
      outline: "0 !important",
      textAlign: "center",
      padding: "6px 3px 3px 3px",
      fontWeight: "300",
      marginLeft: "65px",
    },

    success: {
      // color: '#f0f5ea',
      // backgroundColor: '#a1e82c'
    },

    error: {
      // color: '#f4e9e9',
      // backgroundColor: '#fc727a'
    },

    warning: {
      // color: '#f9f6f0',
      // backgroundColor: '#ffbc67'
    },

    info: {
      // color: '#e8f0f4',
      // backgroundColor: '#63d8f1'
    },
  },

  Action: {
    DefaultStyle: {
      background: "#ffffff",
      borderRadius: "2px",
      padding: "6px 20px",
      fontWeight: "bold",
      margin: "10px 0 0 0",
      border: 0,
    },

    success: {
      backgroundColor: "#a1e82c",
      color: "#ffffff",
    },

    error: {
      backgroundColor: "#fc727a",
      color: "#ffffff",
    },

    warning: {
      backgroundColor: "#ffbc67",
      color: "#ffffff",
    },

    info: {
      backgroundColor: "#63d8f1",
      color: "#ffffff",
    },
  },

  ActionWrapper: {
    DefaultStyle: {
      margin: 0,
      padding: 0,
    },
  },
};

//
// //
// // // For tables
// //
//

const thArray = [
  "Name(名前)",
  "Model(モデル名)",
  "Serial Number(シリアルナンバー)",
  "Share Status(シェア状況)",
  "Access Status(アクセス状況)",
  // "Address(ロケーション（住所))",
  // "Remark(リマーク)"
];
const umthArray = [
  "Lock Name(ハードウェア名)",
  "Shared On(アクセス状況)",
  "Share To(アクセス許可先（サブユーザー）)",
  "Start Date Time(開始日時)",
  "End Date Time(終了日時)",
];
const raArray = [
  "Lock Name(ハードウェア名)",
  "Share To(サブユーザー)",
  "Start Date Time(開始日時)",
  "End Date Time(終了日時)",
  "Remove(サブユーザー削除)",
];
const rmArray = [
  "Recipient Name(サブユーザー名)",
  "Recipient Email(サブユーザーのメールアドレス)",
  "Remove(サブユーザー削除)",
];
const atthArray = [
  "User Email(ユーザーEMAIL)",
  "Lock Status(ハードウェア状況)",
  "Date Time(日時)",
  "Address(ロケーション（住所))",
];

//
// //
// // // For icons
// //
//
const iconsArray = [
  "pe-7s-album",
  "pe-7s-arc",
  "pe-7s-back-2",
  "pe-7s-bandaid",
  "pe-7s-car",
  "pe-7s-diamond",
  "pe-7s-door-lock",
  "pe-7s-eyedropper",
  "pe-7s-female",
  "pe-7s-gym",
  "pe-7s-hammer",
  "pe-7s-headphones",
  "pe-7s-helm",
  "pe-7s-hourglass",
  "pe-7s-leaf",
  "pe-7s-magic-wand",
  "pe-7s-male",
  "pe-7s-map-2",
  "pe-7s-next-2",
  "pe-7s-paint-bucket",
  "pe-7s-pendrive",
  "pe-7s-photo",
  "pe-7s-piggy",
  "pe-7s-plugin",
  "pe-7s-refresh-2",
  "pe-7s-rocket",
  "pe-7s-settings",
  "pe-7s-shield",
  "pe-7s-smile",
  "pe-7s-usb",
  "pe-7s-vector",
  "pe-7s-wine",
  "pe-7s-cloud-upload",
  "pe-7s-cash",
  "pe-7s-close",
  "pe-7s-bluetooth",
  "pe-7s-cloud-download",
  "pe-7s-way",
  "pe-7s-close-circle",
  "pe-7s-id",
  "pe-7s-angle-up",
  "pe-7s-wristwatch",
  "pe-7s-angle-up-circle",
  "pe-7s-world",
  "pe-7s-angle-right",
  "pe-7s-volume",
  "pe-7s-angle-right-circle",
  "pe-7s-users",
  "pe-7s-angle-left",
  "pe-7s-user-female",
  "pe-7s-angle-left-circle",
  "pe-7s-up-arrow",
  "pe-7s-angle-down",
  "pe-7s-switch",
  "pe-7s-angle-down-circle",
  "pe-7s-scissors",
  "pe-7s-wallet",
  "pe-7s-safe",
  "pe-7s-volume2",
  "pe-7s-volume1",
  "pe-7s-voicemail",
  "pe-7s-video",
  "pe-7s-user",
  "pe-7s-upload",
  "pe-7s-unlock",
  "pe-7s-umbrella",
  "pe-7s-trash",
  "pe-7s-tools",
  "pe-7s-timer",
  "pe-7s-ticket",
  "pe-7s-target",
  "pe-7s-sun",
  "pe-7s-study",
  "pe-7s-stopwatch",
  "pe-7s-star",
  "pe-7s-speaker",
  "pe-7s-signal",
  "pe-7s-shuffle",
  "pe-7s-shopbag",
  "pe-7s-share",
  "pe-7s-server",
  "pe-7s-search",
  "pe-7s-film",
  "pe-7s-science",
  "pe-7s-disk",
  "pe-7s-ribbon",
  "pe-7s-repeat",
  "pe-7s-refresh",
  "pe-7s-add-user",
  "pe-7s-refresh-cloud",
  "pe-7s-paperclip",
  "pe-7s-radio",
  "pe-7s-note2",
  "pe-7s-print",
  "pe-7s-network",
  "pe-7s-prev",
  "pe-7s-mute",
  "pe-7s-power",
  "pe-7s-medal",
  "pe-7s-portfolio",
  "pe-7s-like2",
  "pe-7s-plus",
  "pe-7s-left-arrow",
  "pe-7s-play",
  "pe-7s-key",
  "pe-7s-plane",
  "pe-7s-joy",
  "pe-7s-photo-gallery",
  "pe-7s-pin",
  "pe-7s-phone",
  "pe-7s-plug",
  "pe-7s-pen",
  "pe-7s-right-arrow",
  "pe-7s-paper-plane",
  "pe-7s-delete-user",
  "pe-7s-paint",
  "pe-7s-bottom-arrow",
  "pe-7s-notebook",
  "pe-7s-note",
  "pe-7s-next",
  "pe-7s-news-paper",
  "pe-7s-musiclist",
  "pe-7s-music",
  "pe-7s-mouse",
  "pe-7s-more",
  "pe-7s-moon",
  "pe-7s-monitor",
  "pe-7s-micro",
  "pe-7s-menu",
  "pe-7s-map",
  "pe-7s-map-marker",
  "pe-7s-mail",
  "pe-7s-mail-open",
  "pe-7s-mail-open-file",
  "pe-7s-magnet",
  "pe-7s-loop",
  "pe-7s-look",
  "pe-7s-lock",
  "pe-7s-lintern",
  "pe-7s-link",
  "pe-7s-like",
  "pe-7s-light",
  "pe-7s-less",
  "pe-7s-keypad",
  "pe-7s-junk",
  "pe-7s-info",
  "pe-7s-home",
  "pe-7s-help2",
  "pe-7s-help1",
  "pe-7s-graph3",
  "pe-7s-graph2",
  "pe-7s-graph1",
  "pe-7s-graph",
  "pe-7s-global",
  "pe-7s-gleam",
  "pe-7s-glasses",
  "pe-7s-gift",
  "pe-7s-folder",
  "pe-7s-flag",
  "pe-7s-filter",
  "pe-7s-file",
  "pe-7s-expand1",
  "pe-7s-exapnd2",
  "pe-7s-edit",
  "pe-7s-drop",
  "pe-7s-drawer",
  "pe-7s-download",
  "pe-7s-display2",
  "pe-7s-display1",
  "pe-7s-diskette",
  "pe-7s-date",
  "pe-7s-cup",
  "pe-7s-culture",
  "pe-7s-crop",
  "pe-7s-credit",
  "pe-7s-copy-file",
  "pe-7s-config",
  "pe-7s-compass",
  "pe-7s-comment",
  "pe-7s-coffee",
  "pe-7s-cloud",
  "pe-7s-clock",
  "pe-7s-check",
  "pe-7s-chat",
  "pe-7s-cart",
  "pe-7s-camera",
  "pe-7s-call",
  "pe-7s-calculator",
  "pe-7s-browser",
  "pe-7s-box2",
  "pe-7s-box1",
  "pe-7s-bookmarks",
  "pe-7s-bicycle",
  "pe-7s-bell",
  "pe-7s-battery",
  "pe-7s-ball",
  "pe-7s-back",
  "pe-7s-attention",
  "pe-7s-anchor",
  "pe-7s-albums",
  "pe-7s-alarm",
  "pe-7s-airplay",
];

//
// //
// // // // For dashboard's charts
// //
//

// Data for Line Chart
var dataSales = {
  labels: [
    "9:00AM",
    "12:00AM",
    "14:00PM",
    "18:00PM",
    "20:00PM",
    "24:00AM",
    "6:00AM",
  ],
  series: [
    [5, 2, 9, 7, 3, 5, 1],
    [0, 8, 7, 11, 18, 2, 7],
    [11, 20, 17, 3, 9, 7, 12],
  ],
};
var optionsSales = {
  low: 0,
  high: 20,
  showArea: false,
  height: "245px",
  axisX: {
    showGrid: false,
  },
  lineSmooth: true,
  showLine: true,
  showPoint: true,
  fullWidth: true,
  chartPadding: {
    right: 50,
  },
};
var responsiveSales = [
  [
    "screen and (min-width: 641px) and (max-width: 1024px)",
    {
      axisX: {
        labelInterpolationFnc: function(value) {
          return value[0];
        },
      },
    },
  ],
];
var legendSales = {
  names: ["Gate 100", "Gate 101", "Gate 103", "Gate 104", "Gate 105"],
  types: ["info", "danger", "warning"],
};

// Data for Bar Chart
var dataBar = {
  labels: [
    '"Gate 100"',
    '"Gate 101"',
    '"Electrical Riser"',
    '"Warehouse 2"',
    '"Gate 103"',
    '"Gate 107"',
    '"Gate 107"',
  ],
  series: [[10, 20, 5, 30, 40, 15]],
};
var optionsBar = {
  seriesBarDistance: 10,
  axisX: {
    showGrid: false,
  },
  width: 480,
  height: 200,
};
//background grid
var responsiveBar = [
  [
    "screen and (max-width: 640px)",
    {
      seriesBarDistance: 5,
      axisX: {
        labelInterpolationFnc: function(value) {
          return value[0];
        },
      },
    },
  ],
];
var legendBar = {
  names: ["Locks"],
  types: ["info"],
};

var egeeTouchplan1Id,
  egeeTouchplan2Id,
  egeeTouchplan3Id,
  egeeTouchplan4Id,
  egeeTouchplan5Id,
  egeeTouchplan6Id,
  egeeTouchplan1AnnualId,
  egeeTouchplan2AnnualId,
  egeeTouchplan3AnnualId,
  egeeTouchplan5AnnualId,
  egeeTouchplan6AnnualId,
  egeeTouchplan1IdJP,
  egeeTouchplan2IdJP,
  egeeTouchplan3IdJP,
  egeeTouchplan5IdJP,
  egeeTouchplan6IdJP,
  egeeTouchplan1AnnualIdJP,
  egeeTouchplan2AnnualIdJP,
  egeeTouchplan3AnnualIdJP,
  egeeTouchplan5AnnualIdJP,
  egeeTouchplan6AnnualIdJP,
  egeeTouchplan1IdUK,
  egeeTouchplan2IdUK,
  egeeTouchplan3IdUK,
  egeeTouchplan5IdUK,
  egeeTouchplan6IdUK,
  egeeTouchplan1AnnualIdUK,
  egeeTouchplan2AnnualIdUK,
  egeeTouchplan3AnnualIdUK,
  egeeTouchplan5AnnualIdUK,
  egeeTouchplan6AnnualIdUK,
  egeeTouchplan21Id,
  egeeTouchplan22Id,
  egeeTouchplan23Id,
  egeeTouchplan24Id,
  egeeTouchplan25Id,
  egeeTouchplan26Id,
  egeeTouchplan27Id,
  egeeTouchplan21AnnualId,
  egeeTouchplan22AnnualId,
  egeeTouchplan23AnnualId,
  egeeTouchplan24AnnualId,
  egeeTouchplan25AnnualId,
  egeeTouchplan26AnnualId,
  egeeTouchplan27AnnualId = "";

if (deploymentEnvironment) {
  /**
   *
   //* LIVE ENVIRONMENT
   *
   */

  //egeeTouchplan1Id = "plan_GlFjREEpyfTlM0"; //Normal Pricing
  //egeeTouchplan2Id = "plan_GlFoTORH55cgV2"; //Normal Pricing
  //egeeTouchplan3Id = "plan_GlFoouK9qOGIJl"; //Normal Pricing

  // egeeTouchplan4Id = "plan_H5VpvbjpCIsxSb"; //Normal Pricing Custom
  // egeeTouchplan4Id = "price_1Hgm11LkPamFQUX6gOc8Vs9y"; //New Custom Plan
  // egeeTouchplan4Id = "price_1HhWoCLkPamFQUX6nMIin6Lu"; //Second New Custom Plan
  // egeeTouchplan4Id = "price_1IppuYLkPamFQUX6YBmMeKyF"; //Third New Custom Plan
  //egeeTouchplan4Id = "price_1JNBdDLkPamFQUX6O0pEax5k"; //Fourth New Custom Plan
  // egeeTouchplan4Id = "price_1JVAmRLkPamFQUX66wM3O3O7"; // FIFTH New Custom Plan in UK pounds
  // egeeTouchplan4Id = "price_1JzGt0LkPamFQUX6oPa3Brf2"; // Sixth New Custom Plan
  // egeeTouchplan4Id = "price_1KlljpLkPamFQUX6nnVEO2xK"; // Seventh New Custom Plan
  egeeTouchplan4Id = "price_1LofKVLkPamFQUX68jgFs3vb"; // 8th New Custom Plan (MontHly) USD

  //! US
  //? Monthly
  egeeTouchplan1Id = "price_1HtpOrLkPamFQUX65rkp6vvi"; // -15% Monthly Pricing Starter US
  egeeTouchplan2Id = "price_1HtpOrLkPamFQUX6kkQvwwdh"; // -15% Monthly Pricing Essential US
  egeeTouchplan3Id = "price_1HtpOrLkPamFQUX67v9QDzse"; // -15% Monthly Pricing Pro US
  egeeTouchplan5Id = "price_1I9MJELkPamFQUX6XOI7abJG"; // -15% Monthly Pricing Starter Plus US
  egeeTouchplan6Id = "price_1I9SpoLkPamFQUX6Ad9aBqPs"; // -15% Monthly Pricing Essential Plus US

  //?Yearly
  egeeTouchplan1AnnualId = "price_1HtpOrLkPamFQUX6svbKH6HZ"; // -25% Annual Pricing Starter US
  egeeTouchplan2AnnualId = "price_1HtpOrLkPamFQUX611Yeglag"; // -25% Annual Pricing Essential US
  egeeTouchplan3AnnualId = "price_1HtpOrLkPamFQUX6SVYgHthm"; // -25% Annual Pricing Pro US
  egeeTouchplan5AnnualId = "price_1I9SmOLkPamFQUX6GApPqfYC"; // -25% Annual Pricing Starter Plus US
  egeeTouchplan6AnnualId = "price_1I9SrWLkPamFQUX6ttxmmU3o"; // -25% Annual Pricing Essential Plus US

  //! JP
  //? Monthly
  egeeTouchplan1IdJP = "price_1HtpOrLkPamFQUX6AQxysoUL"; // -15% Monthly Pricing Starter JP
  egeeTouchplan2IdJP = "price_1HtpOrLkPamFQUX6oXTy3mwh"; // -15% Monthly Pricing Essential JP
  egeeTouchplan3IdJP = "price_1HtpOrLkPamFQUX69nPFsQTv"; // -15% Monthly Pricing Pro JP
  egeeTouchplan5IdJP = "price_1I9SkbLkPamFQUX6rjzuMVAo"; // -15% Monthly Pricing Starter Plus JP
  egeeTouchplan6IdJP = "price_1I9SqhLkPamFQUX6tYYKmqXK"; // -15% Monthly Pricing Essential Plus JP

  //?Yearly
  egeeTouchplan1AnnualIdJP = "price_1HtpOrLkPamFQUX6gOV9VuQX"; // -25% Annual Pricing Starter JP
  egeeTouchplan2AnnualIdJP = "price_1HtpOrLkPamFQUX6XjDoO6sY"; // -25% Annual Pricing Essential JP
  egeeTouchplan3AnnualIdJP = "price_1HtpOrLkPamFQUX6vgXd9bO2"; // -25% Annual Pricing Pro JP
  egeeTouchplan5AnnualIdJP = "price_1I9SnjLkPamFQUX6hKon7sM2"; // -25% Annual Pricing Starter Plus JP
  egeeTouchplan6AnnualIdJP = "price_1I9SstLkPamFQUX6MPdI1dM8"; // -25% Annual Pricing Essential Plus JP

  //! UK
  //? Monthly
  egeeTouchplan1IdUK = "price_1QRnBsLkPamFQUX6WjlKebqS"; // -15% Monthly Pricing Starter UK
  egeeTouchplan2IdUK = "price_1QRnDILkPamFQUX6bXHgOBKd"; // -15% Monthly Pricing Essential UK
  egeeTouchplan3IdUK = "price_1QRnDuLkPamFQUX66jQWvMFS"; // -15% Monthly Pricing Pro UK
  egeeTouchplan5IdUK = "price_1QRnCFLkPamFQUX6Qvzzmb7S"; //-15% Monthly Pricing Starter Plus UK
  egeeTouchplan6IdUK = "price_1QRnDdLkPamFQUX6YqNN3eel"; //-15% Monthly Pricing Essential Plus UK

  //?Yearly
  egeeTouchplan1AnnualIdUK = "price_1QRnEhLkPamFQUX6u043lm9F"; // -25% Annual Pricing Starter UK
  egeeTouchplan2AnnualIdUK = "price_1QRnFOLkPamFQUX6HIjwUbTL"; // -25% Annual Pricing Essential UK
  egeeTouchplan3AnnualIdUK = "price_1QRnG5LkPamFQUX6Rz4HjnZU"; // -25% Annual Pricing Pro UK
  egeeTouchplan5AnnualIdUK = "price_1QRnF6LkPamFQUX6pypWPY5h"; // -25% Annual Pricing Starter Plus UK
  egeeTouchplan6AnnualIdUK = "price_1QRnFnLkPamFQUX6JVIyh1La"; // -25% Annual Pricing Essential Plus UK

  //! NEW PLANS
  //? Monthly
  egeeTouchplan21Id = "price_1S0EbnLkPamFQUX6zlRCY5jN"; //Monthly Pricing Free Plan
  egeeTouchplan22Id = "price_1S0EnLLkPamFQUX66J5ZZUxX"; //Monthly Pricing Starter Plan
  egeeTouchplan23Id = "price_1S0Eq3LkPamFQUX6i2r3W7y6"; //Monthly Pricing Lock Focus Plan
  egeeTouchplan24Id = "price_1S0EqNLkPamFQUX6rxaHR7nk"; //Monthly Pricing Pro Locks Plan
  egeeTouchplan25Id = "price_1S0G5mLkPamFQUX6kh7imbLs"; //Monthly Pricing User Focus Plan
  egeeTouchplan26Id = "price_1S0G6xLkPamFQUX6PNKWVcnh"; //Monthly Pricing Pro Users Plan
  egeeTouchplan27Id = "price_1S0GAILkPamFQUX6fbWlWu4S"; //Monthly Pricing Large App Plan

  //?Yearly
  egeeTouchplan21AnnualId = ""; //-12% Annual Pricing Free Plan
  egeeTouchplan22AnnualId = "price_1S0GAyLkPamFQUX6TE30qTET"; //-12% Annual Pricing Starter Plan
  egeeTouchplan23AnnualId = "price_1S0GBTLkPamFQUX6gyzJj6YE"; //-12% Annual Pricing Lock Focus Plan
  egeeTouchplan24AnnualId = "price_1S0GC4LkPamFQUX6D5UEpePU"; //-12% Annual Pricing Pro Locks Plan
  egeeTouchplan25AnnualId = "price_1S0GCdLkPamFQUX6gvkhSuK1"; //-12% Annual Pricing User Focus Plan
  egeeTouchplan26AnnualId = "price_1S0GD2LkPamFQUX6Sh2Gw2OV"; //-12% Annual Pricing Pro Users Plan
  egeeTouchplan27AnnualId = "price_1S0GDTLkPamFQUX6UshKf6hy"; //-12% Annual Pricing Large App Plan
} else {
  /**
   *
   //* TEST ENVIRONMENT
   *
   */
  //egeeTouchplan1Id = "plan_Glz44GatKxDebY"; //Normal Pricing
  //egeeTouchplan2Id = "plan_Glz4BOHW5rhO23"; //Normal Pricing
  //egeeTouchplan3Id = "plan_Glz40YGDcspuY5"; //Normal Pricing

  //egeeTouchplan1AnnualId = "price_1Gx7mqLkPamFQUX699Yazu0J"; //Normal Pricing Annual
  //egeeTouchplan2AnnualId = "price_1Gx7nMLkPamFQUX6HY46Rk6f"; //Normal Pricing Annual
  //egeeTouchplan3AnnualId = "price_1Gx7nfLkPamFQUX6Zwq4aZY7"; //Normal Pricing Annual

  // egeeTouchplan4Id = "plan_H5VmTZSaxSm4QS"; //Normal Pricing Custom
  // egeeTouchplan4Id = "price_1HgRYqLkPamFQUX6WaahKPwr"; //New Custom Plan
  // egeeTouchplan4Id = "price_1HhX7pLkPamFQUX6q2ao1JgM"; //Second New Custom Plan
  // egeeTouchplan4Id = "price_1IppXjLkPamFQUX6m45vpvAB"; //Third New Custom Plan
  //egeeTouchplan4Id = "price_1JNBb9LkPamFQUX6pTAtXVIh"; //Fourth New Custom Plan
  // egeeTouchplan4Id = "price_1JVAkDLkPamFQUX6dKMoEYqc"; //Fifth New Custom Plan UK Pounds
  // egeeTouchplan4Id = "price_1JzGsILkPamFQUX6I2eLA0Md"; //Sixth New Custom Plan
  //egeeTouchplan4Id = "price_1KllktLkPamFQUX61wFkudNW"; // Seventh New Custom Plan
  egeeTouchplan4Id = "price_1LofIaLkPamFQUX6GaTMEk8x"; // 8th New Custom Plan (Monthly) USD

  //! US
  //? Monthly
  egeeTouchplan1Id = "price_1Htp8BLkPamFQUX6Gzhxm2P6"; // -15% Monthly Pricing Starter US
  egeeTouchplan2Id = "price_1Htp8fLkPamFQUX6q6VNs0yn"; // -15% Monthly Pricing Essential US
  egeeTouchplan3Id = "price_1Htp8nLkPamFQUX65DxJNtIe"; // -15% Monthly Pricing Pro US
  egeeTouchplan5Id = "price_1I9MvRLkPamFQUX6aXllLrZW"; // -15% Monthly Pricing Starter Plus US
  egeeTouchplan6Id = "price_1I9SaCLkPamFQUX6CzUCGIv5"; // -15% Monthly Pricing Essential Plus US

  //?Yearly
  egeeTouchplan1AnnualId = "price_1Htp9ELkPamFQUX637bOrozc"; // -25% Annual Pricing Starter US
  egeeTouchplan2AnnualId = "price_1Htp9PLkPamFQUX6bIrG2zEV"; // -25% Annual Pricing Essential US
  egeeTouchplan3AnnualId = "price_1Htp9ZLkPamFQUX6BJHjxiaI"; // -25% Annual Pricing Pro US
  egeeTouchplan5AnnualId = "price_1I9SW8LkPamFQUX6lfarkeCd"; // -25% Annual Pricing Starter Plus US
  egeeTouchplan6AnnualId = "price_1I9SdGLkPamFQUX60q4yenOp"; // -25% Annual Pricing Essential Plus US

  //! JP
  //? Monthly
  egeeTouchplan1IdJP = "price_1HtpDLLkPamFQUX6ZCeIt8EM"; // -15% Monthly Pricing Starter JP
  egeeTouchplan2IdJP = "price_1HtpDgLkPamFQUX6F78owgg2"; // -15% Monthly Pricing Essential JP
  egeeTouchplan3IdJP = "price_1HtpE0LkPamFQUX6z9BgS3QQ"; // -15% Monthly Pricing Pro JP
  egeeTouchplan5IdJP = "price_1I9SSNLkPamFQUX6Br8FovcV"; // -15% Monthly Pricing Starter Plus JP
  egeeTouchplan6IdJP = "price_1I9ScVLkPamFQUX6Vg5Ht7iE"; // -15% Monthly Pricing Essential Plus JP

  //?Yearly
  egeeTouchplan1AnnualIdJP = "price_1HtpEQLkPamFQUX6LZypteLk"; // -25% Annual Pricing Starter JP
  egeeTouchplan2AnnualIdJP = "price_1HtpEkLkPamFQUX6CE5eUHDx"; // -25% Annual Pricing Essential JP
  egeeTouchplan3AnnualIdJP = "price_1HtpFJLkPamFQUX6ZB3VFGo2"; // -25% Annual Pricing Pro JP
  egeeTouchplan5AnnualIdJP = "price_1I9SYOLkPamFQUX6H1HvZ0Ie"; // -25% Annual Pricing Starter Plus JP
  egeeTouchplan6AnnualIdJP = "price_1I9SfMLkPamFQUX6K2eKQe4F"; // -25% Annual Pricing Essential Plus JP

  //!UK
  //?Monthly
  egeeTouchplan1IdUK = "price_1Htp9rLkPamFQUX66P3ISfIJ"; // -15% Monthly Pricing Starter UK
  egeeTouchplan2IdUK = "price_1HtpBALkPamFQUX62J9uq4wT"; // -15% Monthly Pricing Essential UK
  egeeTouchplan3IdUK = "price_1HtpBPLkPamFQUX6vXdsPoNC"; // -15% Monthly Pricing Pro UK
  egeeTouchplan5IdUK = "price_1I9Mw1LkPamFQUX6ydDce2QG"; //-15% Monthly Pricing Starter Plus UK
  egeeTouchplan6IdUK = "price_1I9SbELkPamFQUX6uKGZHwW5"; //-15% Monthly Pricing Essential Plus UK

  //?Yearly
  egeeTouchplan1AnnualIdUK = "price_1HtpBoLkPamFQUX68uCKKDBJ"; // -25% Annual Pricing Starter UK
  egeeTouchplan2AnnualIdUK = "price_1HtpCcLkPamFQUX6Tn52OUKi"; // -25% Annual Pricing Essential UK
  egeeTouchplan3AnnualIdUK = "price_1HtpCsLkPamFQUX6V1Q4Ldvo"; // -25% Annual Pricing Pro UK
  egeeTouchplan5AnnualIdUK = "price_1I9SXXLkPamFQUX6bvufXqKD"; // -25% Annual Pricing Starter Plus UK
  egeeTouchplan6AnnualIdUK = "price_1I9SeQLkPamFQUX6P99x4RoK"; // -25% Annual Pricing Essential Plus UK

  //! NEW PLANS
  //? Monthly
  egeeTouchplan21Id = "price_1SGjcrLkPamFQUX6oPGhwcb7"; //Monthly Pricing Free Plan
  egeeTouchplan22Id = "price_1SAkn9LkPamFQUX6BfseqtFK"; //Monthly Pricing Starter Plan
  egeeTouchplan23Id = "price_1SAkoCLkPamFQUX6SAGZYaMh"; //Monthly Pricing Lock Focus Plan
  egeeTouchplan24Id = "price_1SBSj8LkPamFQUX6SGhz1roc"; //Monthly Pricing Pro Locks Plan
  egeeTouchplan25Id = "price_1SBSk9LkPamFQUX6zLMmqccE"; //Monthly Pricing User Focus Plan
  egeeTouchplan26Id = "price_1SBSkfLkPamFQUX62m2C3aS0"; //Monthly Pricing Pro Users Plan
  egeeTouchplan27Id = "price_1SBSlALkPamFQUX6f550NdmQ"; //Monthly Pricing Large App Plan

  //?Yearly
  egeeTouchplan21AnnualId = ""; //-12% Annual Pricing Free Plan
  egeeTouchplan22AnnualId = "price_1SBSliLkPamFQUX6jR075GhL"; //-12% Annual Pricing Starter Plan
  egeeTouchplan23AnnualId = "price_1SBSo9LkPamFQUX6ur389Flr"; //-12% Annual Pricing Lock Focus Plan
  egeeTouchplan24AnnualId = "price_1SBSqyLkPamFQUX6hzanduxj"; //-12% Annual Pricing Pro Locks Plan
  egeeTouchplan25AnnualId = "price_1SBWJKLkPamFQUX6eMuZUAMa"; //-12% Annual Pricing User Focus Plan
  egeeTouchplan26AnnualId = "price_1SBWLDLkPamFQUX6Z1Sz9FFH"; //-12% Annual Pricing Pro Users Plan
  egeeTouchplan27AnnualId = "price_1SBWOvLkPamFQUX66xu119ix"; //-12% Annual Pricing Large App Plan
}

var egeeTouchPlans = {
  egeeTouchplan1: {
    planName: "Starter",
    planNameJP: "スターター",
    planNameUK: "Starter-UK",
    // planId: "plan_Glz44GatKxDebY", // New Test Plan (Updated)
    planId: egeeTouchplan1Id, //New Live Plan
    planIdJP: egeeTouchplan1IdJP,
    planIdUK: egeeTouchplan1IdUK,
    annualPlanId: egeeTouchplan1AnnualId,
    annualPlanIdJP: egeeTouchplan1AnnualIdJP,
    annualPlanIdUK: egeeTouchplan1AnnualIdUK,

    planPrice: "$16.92",
    planPriceAnnual: "$179.10",
    planPriceJP: "¥1,999",
    planPriceAnnualJP: "¥21,150",
    planPriceUK: "£13.52",
    planPriceAnnualUK: "£143.10",
    // planPrice: "$19.90",
    maxTags: 50,
    maxAcc: 20,
    maxLocks: 50,
    maxMulti: 4,
  },
  egeeTouchplan2: {
    planName: "Essential",
    planNameJP: "エッセンシャル",
    planNameUK: "Essential-UK",
    // planId: "plan_Glz4BOHW5rhO23", //New Test plan (Updated)
    planId: egeeTouchplan2Id, //New Live Plan
    planIdJP: egeeTouchplan2IdJP,
    planIdUK: egeeTouchplan2IdUK,

    annualPlanId: egeeTouchplan2AnnualId,
    annualPlanIdJP: egeeTouchplan2AnnualIdJP,
    annualPlanIdUK: egeeTouchplan2AnnualIdUK,

    // planPrice: "$39.90",
    planPrice: "$33.92",
    planPriceAnnual: "$359.10",
    planPriceJP: "¥3,999",
    planPriceAnnualJP: "¥42,300",
    planPriceUK: "£27.12",
    planPriceAnnualUK: "£287.10",

    maxAcc: 40,
    maxTags: 100,
    maxLocks: 100,
    maxMulti: 4,
  },
  egeeTouchplan3: {
    planName: "Professional",
    planNameJP: "プロ",
    planNameUK: "Professional-UK",
    // planId: "plan_Glz40YGDcspuY5", //New Test Plan (Updated)
    planId: egeeTouchplan3Id, //New Live Plan
    planIdJP: egeeTouchplan3IdJP,
    planIdUK: egeeTouchplan3IdUK,

    annualPlanId: egeeTouchplan3AnnualId,
    annualPlanIdJP: egeeTouchplan3AnnualIdJP,
    annualPlanIdUK: egeeTouchplan3AnnualIdUK,

    planPrice: "$84.92",
    planPriceAnnual: "$899.10",
    planPriceJP: "¥9,999",
    planPriceAnnualJP: "¥105,840",
    planPriceUK: "£67.92",
    planPriceAnnualUK: "£719.10",

    // planPrice: "$99.90",
    maxAcc: 100,
    maxTags: 200,
    maxLocks: 500,
    maxMulti: 8,
  },
  egeeTouchplan4: {
    planName: "Custom",
    planId: egeeTouchplan4Id,
    planNumber: 4,
    planPrice: "$50.92", //MONTHLY - planPrice , ANNUAL - planPriceAnnual
    maxAcc: 275,
    maxLocks: 45,
    maxTags: 200,
    maxMulti: 8,
    originalDisplayPrice: 200,
    discountedDisplayPrice: 300,
    discountDisplay: "20%",
    planDurationDisplay: "2 years",
    trial_period_days: 0,
    //added code input
    customCode: "C00000000000",

    // planName: "2-Year Custom",
    // planId: egeeTouchplan4Id,
    // planPrice: "$19.90", //MONTHLY - planPrice , ANNUAL - planPriceAnnual
    // maxAcc: 70,
    // maxLocks: 30,
    // maxTags: 200,
    // maxMulti: 4

    // planName: "2-Year Custom",
    // planId: egeeTouchplan4Id,
    // planPrice: "$19.90", //MONTHLY - planPrice , ANNUAL - planPriceAnnual
    // maxAcc: 20,
    // maxLocks: 50,
    // maxTags: 200,
    // maxMulti: 4
    // planName: "1-Year Custom",
    // planId: egeeTouchplan4Id,
    // planPriceAnnual: "$1557.30", //MONTHLY - planPrice , ANNUAL - planPriceAnnual
    // maxAcc: 1200,
    // maxLocks: 10,
    // maxTags: 200,
    // maxMulti: 8
    // planName: "2-Year Custom",
    // planId: egeeTouchplan4Id,
    // planPriceAnnual: "$214.92",
    // maxAcc: 200,
    // maxLocks: 12,
    // maxTags: 200,
    // maxMulti: 4
    // ------------------------------------
    // planName: "Custom",
    // planId: egeeTouchplan4Id,
    // planPriceAnnual: "$214.92",
    // maxAcc: 20,
    // maxLocks: 50,
    // maxTags: 200,
    // maxMulti: 4
  },
  egeeTouchplan5: {
    planName: "Starter Plus",
    planNameJP: "スタータープラス",
    planNameUK: "Starter-Plus-UK",
    // planId: "plan_Glz44GatKxDebY", // New Test Plan (Updated)
    planId: egeeTouchplan5Id, //New Live Plan
    planIdJP: egeeTouchplan5IdJP,
    planIdUK: egeeTouchplan5IdUK,
    annualPlanId: egeeTouchplan5AnnualId,
    annualPlanIdJP: egeeTouchplan5AnnualIdJP,
    annualPlanIdUK: egeeTouchplan5AnnualIdUK,

    planPrice: "$25.42",
    planPriceAnnual: "$269.10",
    planPriceJP: "¥2,999",
    planPriceAnnualJP: "¥31,670",
    planPriceUK: "£20.32",
    planPriceAnnualUK: "£215.10",
    // planPrice: "$19.90",
    maxTags: 50,
    maxAcc: 200,
    maxLocks: 12,
    maxMulti: 4,
  },
  egeeTouchplan6: {
    planName: "Essential Plus",
    planNameJP: "エッセンシャルプラス",
    planNameUK: "Essential-Plus-UK",
    // planId: "plan_Glz4BOHW5rhO23", //New Test plan (Updated)
    planId: egeeTouchplan6Id, //New Live Plan
    planIdJP: egeeTouchplan6IdJP,
    planIdUK: egeeTouchplan6IdUK,

    annualPlanId: egeeTouchplan6AnnualId,
    annualPlanIdJP: egeeTouchplan6AnnualIdJP,
    annualPlanIdUK: egeeTouchplan6AnnualIdUK,

    // planPrice: "$39.90",
    planPrice: "$50.92",
    planPriceAnnual: "$539.10",
    planPriceJP: "¥5,999",
    planPriceAnnualJP: "¥63,450",
    planPriceUK: "£40.72",
    planPriceAnnualUK: "£431.10",

    maxAcc: 500,
    maxTags: 100,
    maxLocks: 24,
    maxMulti: 8,
  },
  egeeTouchplan21: {
    planName: "Free",
    planNameJP: "無料プラン",
    planNameUK: "Free",
    // planId: "plan_Glz44GatKxDebY", // New Test Plan (Updated)
    planId: egeeTouchplan21Id, //New Live Plan
    planIdJP: egeeTouchplan21Id,
    planIdUK: egeeTouchplan21Id,
    annualPlanId: egeeTouchplan21AnnualId,
    annualPlanIdJP: egeeTouchplan21AnnualId,
    annualPlanIdUK: egeeTouchplan21AnnualId,

    planPrice: "$0.00",
    planPriceAnnual: "$0.00",
    planPriceJP: "¥$0.00",
    planPriceAnnualJP: "$0.00",
    planPriceUK: "$0.00",
    planPriceAnnualUK: "$0.00",
    // planPrice: "$19.90",
    maxTags: 2,
    maxAcc: 2,
    maxLocks: 2,
    maxMulti: 0,
  },
  egeeTouchplan22: {
    planName: "Starter New",
    planNameJP: "スタータープラン",
    planNameUK: "Starter New",
    // planId: "plan_Glz4BOHW5rhO23", //New Test plan (Updated)
    planId: egeeTouchplan22Id, //New Live Plan
    planIdJP: egeeTouchplan22Id,
    planIdUK: egeeTouchplan22Id,

    annualPlanId: egeeTouchplan22AnnualId,
    annualPlanIdJP: egeeTouchplan22AnnualId,
    annualPlanIdUK: egeeTouchplan22AnnualId,

    // planPrice: "$39.90",
    planPrice: "$7.90",
    planPriceAnnual: "$83.42",
    planPriceJP: "$7.90",
    planPriceAnnualJP: "$83.42",
    planPriceUK: "$7.90",
    planPriceAnnualUK: "$83.42",

    maxAcc: 4,
    maxTags: 4,
    maxLocks: 5,
    maxMulti: 1,
  },
  egeeTouchplan23: {
    planName: "Lock Focus",
    planNameJP: "LFプラン",
    planNameUK: "Lock Focus",
    // planId: "plan_Glz40YGDcspuY5", //New Test Plan (Updated)
    planId: egeeTouchplan23Id, //New Live Plan
    planIdJP: egeeTouchplan23Id,
    planIdUK: egeeTouchplan23Id,

    annualPlanId: egeeTouchplan23AnnualId,
    annualPlanIdJP: egeeTouchplan23AnnualId,
    annualPlanIdUK: egeeTouchplan23AnnualId,

    planPrice: "$24.90",
    planPriceAnnual: "$262.94",
    planPriceJP: "$24.90",
    planPriceAnnualJP: "$262.94",
    planPriceUK: "$24.90",
    planPriceAnnualUK: "$262.94",

    // planPrice: "$99.90",
    maxAcc: 10,
    maxTags: 10,
    maxLocks: 25,
    maxMulti: 2,
  },
  egeeTouchplan24: {
    planName: "Pro Locks",
    planNameJP: "Pro-LFプラン",
    planNameUK: "Pro Locks",
    // planId: "plan_Glz40YGDcspuY5", //New Test Plan (Updated)
    planId: egeeTouchplan24Id, //New Live Plan
    planIdJP: egeeTouchplan24Id,
    planIdUK: egeeTouchplan24Id,

    annualPlanId: egeeTouchplan24AnnualId,
    annualPlanIdJP: egeeTouchplan24AnnualId,
    annualPlanIdUK: egeeTouchplan24AnnualId,

    planPrice: "$109.00",
    planPriceAnnual: "$1,151.04",
    planPriceJP: "$109.00",
    planPriceAnnualJP: "$1,151.04",
    planPriceUK: "$109.00",
    planPriceAnnualUK: "$1,151.04",

    // planPrice: "$99.90",
    maxAcc: 25,
    maxTags: 75,
    maxLocks: 300,
    maxMulti: 4,
  },
  egeeTouchplan25: {
    planName: "User Focus",
    planNameJP: "UFプラン",
    planNameUK: "User Focus",
    // planId: "plan_Glz40YGDcspuY5", //New Test Plan (Updated)
    planId: egeeTouchplan25Id, //New Live Plan
    planIdJP: egeeTouchplan25Id,
    planIdUK: egeeTouchplan25Id,

    annualPlanId: egeeTouchplan25AnnualId,
    annualPlanIdJP: egeeTouchplan25AnnualId,
    annualPlanIdUK: egeeTouchplan25AnnualId,

    planPrice: "$69.90",
    planPriceAnnual: "$738.14",
    planPriceJP: "$69.90",
    planPriceAnnualJP: "$738.14",
    planPriceUK: "$69.90",
    planPriceAnnualUK: "$738.14",

    // planPrice: "$99.90",
    maxAcc: 40,
    maxTags: 30,
    maxLocks: 4,
    maxMulti: 2,
  },
  egeeTouchplan26: {
    planName: "Pro Users",
    planNameJP: "Pro-UFプラン",
    planNameUK: "Pro Users",
    // planId: "plan_Glz40YGDcspuY5", //New Test Plan (Updated)
    planId: egeeTouchplan26Id, //New Live Plan
    planIdJP: egeeTouchplan26Id,
    planIdUK: egeeTouchplan26Id,

    annualPlanId: egeeTouchplan26AnnualId,
    annualPlanIdJP: egeeTouchplan26AnnualId,
    annualPlanIdUK: egeeTouchplan26AnnualId,

    planPrice: "$199.00",
    planPriceAnnual: "$2,101.44",
    planPriceJP: "$199.00",
    planPriceAnnualJP: "$2,101.44",
    planPriceUK: "$199.00",
    planPriceAnnualUK: "$2,101.44",

    // planPrice: "$99.90",
    maxAcc: 180,
    maxTags: 100,
    maxLocks: 10,
    maxMulti: 4,
  },
  egeeTouchplan27: {
    planName: "Large App",
    planNameJP: "LAプラン",
    planNameUK: "Large App",
    // planId: "plan_Glz40YGDcspuY5", //New Test Plan (Updated)
    planId: egeeTouchplan27Id, //New Live Plan
    planIdJP: egeeTouchplan27Id,
    planIdUK: egeeTouchplan27Id,

    annualPlanId: egeeTouchplan27AnnualId,
    annualPlanIdJP: egeeTouchplan27AnnualId,
    annualPlanIdUK: egeeTouchplan27AnnualId,

    planPrice: "$478.00",
    planPriceAnnual: "$5,047.68",
    planPriceJP: "$478.00",
    planPriceAnnualJP: "$5,047.68",
    planPriceUK: "$478.00",
    planPriceAnnualUK: "$5,047.68",

    // planPrice: "$99.90",
    maxAcc: 500,
    maxTags: 500,
    maxLocks: 500,
    maxMulti: 8,
  },
};

function planToNumber(data) {
  let planNumber,
    maxLocks,
    maxMulti,
    planPrice,
    maxTags,
    planId,
    annualPlanId,
    planPriceAnnual,
    planPriceAnnualDisplay,
    planPriceDisplay,
    maxUser = 0;

  switch (data) {
    //! US ---------------------------------------------------------------------------------
    case "Starter":
      //us starter
      planNumber = 1;
      planId = egeeTouchPlans.egeeTouchplan1.planId;
      annualPlanId = egeeTouchPlans.egeeTouchplan1.annualPlanId;
      planPrice = egeeTouchPlans.egeeTouchplan1.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan1.planPrice + "/month";
      planPriceAnnual = egeeTouchPlans.egeeTouchplan1.planPriceAnnual;
      planPriceAnnualDisplay =
        egeeTouchPlans.egeeTouchplan1.planPriceAnnual + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan1.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan1.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan1.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan1.maxMulti;
      break;

    default:
      //us essential
      planNumber = 2;
      planId = egeeTouchPlans.egeeTouchplan2.planId;
      annualPlanId = egeeTouchPlans.egeeTouchplan2.annualPlanId;
      planPrice = egeeTouchPlans.egeeTouchplan2.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan2.planPrice + "/month";
      planPriceAnnual = egeeTouchPlans.egeeTouchplan2.planPriceAnnual;
      planPriceAnnualDisplay =
        egeeTouchPlans.egeeTouchplan2.planPriceAnnual + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan2.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan2.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan2.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan2.maxMulti;
      break;

    case "Professional":
      //us professional
      planNumber = 3;
      planId = egeeTouchPlans.egeeTouchplan3.planId;
      annualPlanId = egeeTouchPlans.egeeTouchplan3.annualPlanId;
      planPrice = egeeTouchPlans.egeeTouchplan3.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan3.planPrice + "/month";
      planPriceAnnual = egeeTouchPlans.egeeTouchplan3.planPriceAnnual;
      planPriceAnnualDisplay =
        egeeTouchPlans.egeeTouchplan3.planPriceAnnual + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan3.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan3.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan3.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan3.maxMulti;
      break;

    case "Starter Plus":
      //us starter
      planNumber = 5;
      planId = egeeTouchPlans.egeeTouchplan5.planId;
      annualPlanId = egeeTouchPlans.egeeTouchplan5.annualPlanId;
      planPrice = egeeTouchPlans.egeeTouchplan5.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan5.planPrice + "/month";
      planPriceAnnual = egeeTouchPlans.egeeTouchplan5.planPriceAnnual;
      planPriceAnnualDisplay =
        egeeTouchPlans.egeeTouchplan5.planPriceAnnual + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan5.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan5.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan5.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan5.maxMulti;
      break;

    case "Essential Plus":
      planNumber = 6;
      planId = egeeTouchPlans.egeeTouchplan6.planId;
      annualPlanId = egeeTouchPlans.egeeTouchplan6.annualPlanId;
      planPrice = egeeTouchPlans.egeeTouchplan6.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan6.planPrice + "/month";
      planPriceAnnual = egeeTouchPlans.egeeTouchplan6.planPriceAnnual;
      planPriceAnnualDisplay =
        egeeTouchPlans.egeeTouchplan6.planPriceAnnual + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan6.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan6.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan6.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan6.maxMulti;
      break;
    //! UK ---------------------------------------------------------------------------------
    case "Starter-UK":
      planNumber = 1;
      planId = egeeTouchPlans.egeeTouchplan1.planIdUK;
      annualPlanId = egeeTouchPlans.egeeTouchplan1.annualPlanIdUK;
      planPrice = egeeTouchPlans.egeeTouchplan1.planPriceUK;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan1.planPriceUK + "/month";
      planPriceAnnual = egeeTouchPlans.egeeTouchplan1.planPriceAnnualUK;
      planPriceAnnualDisplay =
        egeeTouchPlans.egeeTouchplan1.planPriceAnnualUK + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan1.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan1.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan1.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan1.maxMulti;
      break;

    case "Essential-UK":
      planNumber = 2;
      planId = egeeTouchPlans.egeeTouchplan2.planIdUK;
      annualPlanId = egeeTouchPlans.egeeTouchplan2.annualPlanIdUK;
      planPrice = egeeTouchPlans.egeeTouchplan2.planPriceUK;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan2.planPriceUK + "/month";
      planPriceAnnual = egeeTouchPlans.egeeTouchplan2.planPriceAnnualUK;
      planPriceAnnualDisplay =
        egeeTouchPlans.egeeTouchplan2.planPriceAnnualUK + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan2.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan2.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan2.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan2.maxMulti;
      break;

    case "Professional-UK":
      planNumber = 3;
      planId = egeeTouchPlans.egeeTouchplan3.planIdUK;
      annualPlanId = egeeTouchPlans.egeeTouchplan3.annualPlanIdUK;
      planPrice = egeeTouchPlans.egeeTouchplan3.planPriceUK;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan3.planPriceUK + "/month";
      planPriceAnnual = egeeTouchPlans.egeeTouchplan3.planPriceAnnualUK;
      planPriceAnnualDisplay =
        egeeTouchPlans.egeeTouchplan3.planPriceAnnualUK + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan3.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan3.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan3.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan3.maxMulti;
      break;

    case "Starter-Plus-UK":
      planNumber = 5;
      planId = egeeTouchPlans.egeeTouchplan5.planIdUK;
      annualPlanId = egeeTouchPlans.egeeTouchplan5.annualPlanIdUK;
      planPrice = egeeTouchPlans.egeeTouchplan5.planPriceUK;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan5.planPriceUK + "/month";
      planPriceAnnual = egeeTouchPlans.egeeTouchplan5.planPriceAnnualUK;
      planPriceAnnualDisplay =
        egeeTouchPlans.egeeTouchplan5.planPriceAnnualUK + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan5.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan5.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan5.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan5.maxMulti;
      break;

    case "Essential-Plus-UK":
      planNumber = 6;
      planId = egeeTouchPlans.egeeTouchplan6.planIdUK;
      annualPlanId = egeeTouchPlans.egeeTouchplan6.annualPlanIdUK;
      planPrice = egeeTouchPlans.egeeTouchplan6.planPriceUK;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan6.planPriceUK + "/month";
      planPriceAnnual = egeeTouchPlans.egeeTouchplan6.planPriceAnnualUK;
      planPriceAnnualDisplay =
        egeeTouchPlans.egeeTouchplan6.planPriceAnnualUK + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan6.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan6.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan6.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan6.maxMulti;
      break;

    //! JP ---------------------------------------------------------------------------------
    //JP
    case "スターター":
      //jp starter
      planNumber = 1;
      planId = egeeTouchPlans.egeeTouchplan1.planIdJP;
      planPrice = egeeTouchPlans.egeeTouchplan1.planPriceJP;
      planPriceDisplay = "月額¥" + egeeTouchPlans.egeeTouchplan1.planPriceJP;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan1.planPriceAnnualJP;
      maxUser = egeeTouchPlans.egeeTouchplan1.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan1.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan1.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan1.maxMulti;
      break;

    case "エッセンシャル":
      //jp essential
      planNumber = 2;
      planId = egeeTouchPlans.egeeTouchplan2.planIdJP;
      planPrice = egeeTouchPlans.egeeTouchplan2.planPriceJP;
      planPriceDisplay = "月額¥" + egeeTouchPlans.egeeTouchplan2.planPriceJP;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan2.planPriceAnnualJP;
      maxLocks = egeeTouchPlans.egeeTouchplan2.maxLocks;
      maxUser = egeeTouchPlans.egeeTouchplan2.maxAcc;
      maxTags = egeeTouchPlans.egeeTouchplan2.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan2.maxMulti;
      break;

    case "プロ":
      //jp professional
      planNumber = 3;
      planId = egeeTouchPlans.egeeTouchplan3.planIdJP;
      planPrice = egeeTouchPlans.egeeTouchplan3.planPriceJP;
      planPriceDisplay = "月額¥" + egeeTouchPlans.egeeTouchplan3.planPriceJP;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan3.planPriceAnnualJP;
      maxUser = egeeTouchPlans.egeeTouchplan3.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan3.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan3.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan3.maxMulti;
      break;

    case "スタータープラス":
      //jp starter
      planNumber = 5;
      planId = egeeTouchPlans.egeeTouchplan5.planIdJP;
      planPrice = egeeTouchPlans.egeeTouchplan5.planPriceJP;
      planPriceDisplay = "月額¥" + egeeTouchPlans.egeeTouchplan5.planPriceJP;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan5.planPriceAnnualJP;
      maxUser = egeeTouchPlans.egeeTouchplan5.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan5.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan5.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan5.maxMulti;
      break;

    case "エッセンシャルプラス":
      //jp essential
      planNumber = 6;
      planId = egeeTouchPlans.egeeTouchplan6.planIdJP;
      planPrice = egeeTouchPlans.egeeTouchplan6.planPriceJP;
      planPriceDisplay = "月額¥" + egeeTouchPlans.egeeTouchplan6.planPriceJP;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan6.planPriceAnnualJP;
      maxLocks = egeeTouchPlans.egeeTouchplan6.maxLocks;
      maxUser = egeeTouchPlans.egeeTouchplan6.maxAcc;
      maxTags = egeeTouchPlans.egeeTouchplan6.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan6.maxMulti;
      break;

    //! CUSTOM ---------------------------------------------------------------------------------

    case "1-Year Custom":
      planNumber = 4;
      planId = egeeTouchPlans.egeeTouchplan4.planId;
      planPrice = egeeTouchPlans.egeeTouchplan4.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan4.planPrice + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan4.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan4.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan4.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan4.maxMulti;
      break;

    case "2-Year Custom":
      planNumber = 4;
      planId = egeeTouchPlans.egeeTouchplan4.planId;
      planPrice = egeeTouchPlans.egeeTouchplan4.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan4.planPrice + "/year";
      maxUser = egeeTouchPlans.egeeTouchplan4.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan4.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan4.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan4.maxMulti;
      break;

    //! NEW PLAN  ---------------------------------------------------------------------------------
    case "Free":
      planNumber = 21;
      planId = egeeTouchPlans.egeeTouchplan21.planId;
      planPrice = egeeTouchPlans.egeeTouchplan21.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan21.planPrice + "/month";

      annualPlanId = egeeTouchPlans.egeeTouchplan21.annualPlanId;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan21.planPriceAnnual;
      planPriceAnnualDisplay = egeeTouchPlans.egeeTouchplan21.planPriceAnnual + "/year";

      maxUser = egeeTouchPlans.egeeTouchplan21.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan21.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan21.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan21.maxMulti;
      break;
    case "Starter New":
      planNumber = 22;
      planId = egeeTouchPlans.egeeTouchplan22.planId;
      planPrice = egeeTouchPlans.egeeTouchplan22.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan22.planPrice + "/month";

      annualPlanId = egeeTouchPlans.egeeTouchplan22.annualPlanId;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan22.planPriceAnnual;
      planPriceAnnualDisplay = egeeTouchPlans.egeeTouchplan22.planPriceAnnual + "/year";

      maxUser = egeeTouchPlans.egeeTouchplan22.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan22.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan22.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan22.maxMulti;
      break;
    case "Lock Focus":
      planNumber = 23;
      planId = egeeTouchPlans.egeeTouchplan23.planId;
      planPrice = egeeTouchPlans.egeeTouchplan23.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan23.planPrice + "/month";

      annualPlanId = egeeTouchPlans.egeeTouchplan23.annualPlanId;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan23.planPriceAnnual;
      planPriceAnnualDisplay = egeeTouchPlans.egeeTouchplan23.planPriceAnnual + "/year";

      maxUser = egeeTouchPlans.egeeTouchplan23.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan23.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan23.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan23.maxMulti;
      break;
    case "Pro Locks":
      planNumber = 24;
      planId = egeeTouchPlans.egeeTouchplan24.planId;
      planPrice = egeeTouchPlans.egeeTouchplan24.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan24.planPrice + "/month";

      annualPlanId = egeeTouchPlans.egeeTouchplan24.annualPlanId;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan24.planPriceAnnual;
      planPriceAnnualDisplay = egeeTouchPlans.egeeTouchplan24.planPriceAnnual + "/year";

      maxUser = egeeTouchPlans.egeeTouchplan24.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan24.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan24.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan24.maxMulti;
      break;
    case "User Focus":
      planNumber = 25;
      planId = egeeTouchPlans.egeeTouchplan25.planId;
      planPrice = egeeTouchPlans.egeeTouchplan25.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan25.planPrice + "/month";

      annualPlanId = egeeTouchPlans.egeeTouchplan25.annualPlanId;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan25.planPriceAnnual;
      planPriceAnnualDisplay = egeeTouchPlans.egeeTouchplan25.planPriceAnnual + "/year";

      maxUser = egeeTouchPlans.egeeTouchplan25.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan25.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan25.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan25.maxMulti;
      break;
    case "Pro Users":
      planNumber = 26;
      planId = egeeTouchPlans.egeeTouchplan26.planId;
      planPrice = egeeTouchPlans.egeeTouchplan26.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan26.planPrice + "/month";

      annualPlanId = egeeTouchPlans.egeeTouchplan26.annualPlanId;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan26.planPriceAnnual;
      planPriceAnnualDisplay = egeeTouchPlans.egeeTouchplan26.planPriceAnnual + "/year";

      maxUser = egeeTouchPlans.egeeTouchplan26.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan26.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan26.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan26.maxMulti;
      break;
    case "Large App":
      planNumber = 27;
      planId = egeeTouchPlans.egeeTouchplan27.planId;
      planPrice = egeeTouchPlans.egeeTouchplan27.planPrice;
      planPriceDisplay = egeeTouchPlans.egeeTouchplan27.planPrice + "/month";

      annualPlanId = egeeTouchPlans.egeeTouchplan27.annualPlanId;
      planPriceAnnual = egeeTouchPlans.egeeTouchplan27.planPriceAnnual;
      planPriceAnnualDisplay = egeeTouchPlans.egeeTouchplan27.planPriceAnnual + "/year";

      maxUser = egeeTouchPlans.egeeTouchplan27.maxAcc;
      maxLocks = egeeTouchPlans.egeeTouchplan27.maxLocks;
      maxTags = egeeTouchPlans.egeeTouchplan27.maxTags;
      maxMulti = egeeTouchPlans.egeeTouchplan27.maxMulti;
      break;
  }

  const callBackData = {
    maxUsers: maxUser,
    planNumber: planNumber,
    maxLocks: maxLocks,
    planPrice: planPrice,
    planPriceDisplay: planPriceDisplay,

    planPriceAnnualDisplay: planPriceAnnualDisplay,
    planPriceAnnual: planPriceAnnual,

    annualPlanId: annualPlanId,

    maxMulti: maxMulti,

    maxTags: maxTags,
    planId: planId,
  };

  return callBackData;
}

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const monthNamesShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const dayOfweek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

function customLog(details) {
  if (!deploymentEnvironment) {
    console.log(details); //! DO NOT CHANGE
  }
}

const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g;
const nameRegexAlphanumeric = /^[a-zA-Z0-9 _-]*$/g;
const emailRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/;

const timestampToDate = (timestamp, format) => {
  const date = new Date(timestamp * 1000);
  let dayOfMonth = date.getDate();
  let month = date.getMonth();
  const year = date.getFullYear();
  var dayInNum = date.getDay() - 1;
  if (dayInNum === -1) {
    dayInNum = 6;
  }

  if (format === "DMTY") {
    return `${dayOfweek[dayInNum]}, ${dayOfMonth} ${monthNamesShort[month]} ${year}`;
  } else if (format === "DMY") {
    if (month.length === 1) {
      month = "0" + month;
    }

    if (dayOfMonth.length === 1) {
      dayOfMonth = "0" + dayOfMonth;
    }

    return `${dayOfMonth} ${dayOfMonth} ${year}`;
  } else if (format === "DDMMYY") {
    if ((month + 1).length === 1) {
      month = "0" + month;
    }

    if (dayOfMonth.length === 1) {
      dayOfMonth = "0" + dayOfMonth;
    }

    return `${dayOfMonth}/${month}/${year}`;
  }
};

module.exports = {
  // For notifications (App container and Notifications view)
  style,
  timestampToDate,
  monthNames,
  monthNamesShort,
  nameRegex,
  nameRegexAlphanumeric,
  emailRegex,
  planToNumber,
  // For tables (AuditTrail, Locklist...)
  thArray,
  umthArray,
  atthArray,
  iconsArray,
  rmArray,
  raArray,
  // For charts (Dashboard view)
  dataSales,
  optionsSales,
  responsiveSales,
  legendSales,
  dataBar,
  optionsBar,
  responsiveBar,
  legendBar,
  egeeTouchPlans,
  customLog,
  deploymentEnvironment,
  SUPER_ADMIN_DETAILS,
};
